// Note: marinaIP is globally declared in parent HTML block
// eslint-disable-next-line no-undef
const API_URL = `https://${marinaIP}`;

export function constructPathURL(path) {
    const sanitizedHost = API_URL.replace(/\/$/, "");
    const sanitizedPath = path.substring(0, 1) === "/" ? path : `/${path}`;

    return sanitizedHost + sanitizedPath;
}
